import { FacturePage } from "components/FacturePage"

export const AdminFacture: React.FC = () => {
  return (
    <FacturePage isAdmin={true} />
  )
}